import type { TFunction } from "i18next";
import { apiErrorDetail } from "@/helpers/apiErrorDetail";

const FEDERATED_USER_LOGIN_NOT_ALLOWED = "FEDERATED_USER_LOGIN_NOT_ALLOWED";

/** Keep authentication feedback consistent across lookup, password, and MFA. */
export const getLoginErrorMessage = (error: unknown, t: TFunction): string => {
  const { message: envelopeMessage, payload, code } = apiErrorDetail(error);
  const message = payload?.message || envelopeMessage;

  if ([message, code].includes(FEDERATED_USER_LOGIN_NOT_ALLOWED)) {
    return t("login.errors.federated");
  }
  return typeof message === "string" && message.trim()
    ? message
    : t("login.errors.unavailable");
};
